export default __webpack_public_path__ + "static/media/13.81c087bf.jpg";